import { Avatar } from '../components/avatar'
import { ErrorNotification, SuccessNotification } from '../components/notification'
import { Button } from '../components/button'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthLayout } from '../components/auth-layout'
import { Field, Label } from '../components/fieldset'
import { Heading } from '../components/heading'
import { Input } from '../components/input'
import { Text } from '../components/text'
import sumoLogo from '../images/sumo_logo.png'
import config from '../config.js'
import { Loader } from '../components/loader'



export default function Login() {
    const [formData, setFormData] = useState({ email: ''});
    const [successMsg, setSuccessMsg] = useState('');
    const [showSuccessBox, setShowSuccessBox] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [showErrorBox, setShowErrorBox] = useState(false);
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState('');
    const [isChecking, setIsChecking] = useState(true);
    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();

    useEffect(() => {
      const checkSession = async () => {
        try {
          const response = await fetch(`${config.apiPath}validate-session/check-session.php`, { method: 'GET',credentials: 'include' });
          const list_res = await response.json();
          if (list_res.loggedIn) {
            window.location.href = `/${config.appPath}dashboard`;
          }
          else {
            setIsChecking(false); // no session, show AuthLayout
          }
        }
        catch (error) {
          console.error("Session check failed:", error);
          navigate('/');
          }
      };
      checkSession();
    }, [navigate]);
     if (isChecking) return null;

    const validate = () => {
        const newErrors = {};

        if (!formData.email) {
        newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Email format is invalid';
        }        

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
        setServerError('');
    };
    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        if (!validate()) return;
         try {
            setLoading(true);
            const response = await fetch(`${config.apiPath}forgot-password.php`, {
                method: 'POST',
				        credentials: 'include',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log('Server response:', result);
            if (result.status === 'success') {
                //navigate('/login');
                setSuccessMsg(result.message);        
                setShowSuccessBox(true);
                setTimeout(() => {
                  setShowSuccessBox(false);
                  setSuccessMsg("");
                  navigate("/"); // redirect after save
                }, 3000);
            } else {
                //setServerError(result.message || 'Login failed.');
                setErrorMsg(result.message);
                setShowErrorBox(true);
                setTimeout(() => {
                  setShowErrorBox(false);
                  setErrorMsg("");
                }, 3000);
            }
            setLoading(false);
        } catch (err) {
            //setServerError('Server error. Please try again later.');
            setErrorMsg('Server error. Please try again later.');
                setShowErrorBox(true);
                setTimeout(() => {
                  setShowErrorBox(false);
                  setErrorMsg("");
                }, 3000);
            setLoading(false);
        }
    };
    return (
    <AuthLayout>
      <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
      <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
      <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8">
        <Avatar src={sumoLogo} className="size-15 mx-auto" square alt="" />
        <Heading>Reset your password</Heading>
        <Text>Enter your email and we’ll send you a link to reset your Password.</Text>
        <Field>
          <Label>Email</Label>
          <Input type="email" name="email" value={formData.email} onChange={handleChange} className={`${
            errors.email ? 'border-red-500 border-1 rounded-lg' : 'border-gray-300'}`}/>
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
        </Field> 
        {serverError && <p className="text-red-600 text-sm">{serverError}</p>}
        <Button type="submit" className="w-full cursor-pointer">
          Submit
        </Button>
      </form>
      {loading && (
        <Loader />
      )}
    </AuthLayout>
  )
}